export default __webpack_public_path__ + "static/motichoorladdoo-b1b2369f8eff0f67e163bac91d33e04e.png";